import { createSelector } from "reselect";
import { surveySectionSelector } from "../survey_section_selector";

export const dateSelectionSelector = createSelector(
  surveySectionSelector,
  survey => {
    return survey.dateSelection;
  }
);
